import React from "react";
import PropTypes from "prop-types";

import Icon from "../Icon";

function PrevArrow(props) {
  const { className, style, onClick } = props;
  const baseClassName =
    "PostCarousel-button PostCarousel-button--prev hide-on-load";

  return (
    <button
      className={`${className} ${baseClassName}`}
      style={{ ...style }}
      type="button"
      onClick={onClick}
    >
      <span className="u-screenreader">Previous</span>
      <Icon name="chevronLeft" height={40} width={20} />
    </button>
  );
}

PrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

export default PrevArrow;
